const FilterId = {
  STATUS: 'filterByStatus',
} as const;

export { FilterId };
